/* Backoffice dashboard — the section list with publish status and
   last-edited, plus a live unread-enquiries stat with quick links. */
import { useSections } from '../content/ContentContext.jsx'
import { Icon } from '../components/Icon.jsx'

function editedLabel(edited) {
  if (!edited) return '—'
  // Firestore Timestamp → short date; string passes through.
  const d = typeof edited.toDate === 'function' ? edited.toDate() : new Date(edited)
  if (isNaN(d)) return '—'
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}

export function Dashboard({ meta, onEdit, unreadCount = 0, onView }) {
  const sections = useSections()
  return (
    <div className="dash-grid">
      <div className="panel">
        <div className="panel-h">
          <span className="pt">Site sections</span>
          <button
            className="pt"
            style={{ color: 'var(--sage)', background: 'none', border: 'none' }}
            onClick={() => onView?.('sections')}
          >
            Manage →
          </button>
        </div>
        {sections.map((s) => {
          const m = meta[s.key] || { status: 'Published' }
          return (
            <div className="sec-row" key={s.key}>
              <div className="sr-num">{s.num}</div>
              <div className="sr-name">
                {s.label}
                {s.hidden && <span className="sr-hidden"> · hidden</span>}
              </div>
              <div className={'status ' + (m.status === 'Published' ? 'pub' : 'draft')}>
                {m.status}
              </div>
              <div className="sr-meta">{editedLabel(m.edited)}</div>
              <button className="sr-edit" onClick={() => onEdit(s.key)}>
                Edit
              </button>
            </div>
          )
        })}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div className="panel">
          <div className="stat-big">
            <div className="num">{unreadCount}</div>
            <div className="lbl">Unread enquiries</div>
          </div>
          <div className="quick-links">
            <button className="qlink" onClick={() => onView?.('enquiries')}>
              <span className="qi">
                <Icon name="inbox" size={17} />
              </span>
              Enquiries
            </button>
            <button className="qlink" onClick={() => onView?.('media')}>
              <span className="qi">
                <Icon name="image" size={17} />
              </span>
              Media library
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
